import React from 'react';
import StatusColumn from 'src/common/utils/TableColumnIcons/StatusColumn';

export const StatusColumnFormat = (value) => {
	return (
		<StatusColumn
			value={value === true ? 'Enviado' : 'No enviado'}
			color={value === true ? 'success' : 'danger'}
			light
		/>
	);
};
